// Telas que já existem no web novo (quiero.q2f.com.br). Quem abrir a rota antiga
// (URL digitada, favorito, link antigo) é mandado para a tela nova pelo RedirectNovoSistema.
// Os :parametros do caminho antigo são repassados para o destino com o mesmo nome.
// Para desativar mais uma tela: incluir aqui, tirar a rota do Routes.js e o export em views/index.js.
const rotasMigradas = [
  // Custos
  { path: '/compras/home', to: '/modulos/custos' },
  { path: '/dashboardCompras', to: '/modulos/custos/dashboard' },
  { path: '/categoriasCompras', to: '/modulos/custos/categorias-compras' },
  { path: '/categoriaCompra', to: '/modulos/custos/categorias-compras/novo' },
  { path: '/categoriaCompra/:id', to: '/modulos/custos/categorias-compras/:id' },
  { path: '/compras', to: '/modulos/custos/compras' },
  { path: '/compra/:id', to: '/modulos/custos/compras/:id' },
  { path: '/relatorioComprasComparativoPrecos', to: '/modulos/custos/relatorios/comparativo-precos' },
  { path: '/relatorioComprasVendas', to: '/modulos/custos/relatorios/compra-venda' },
  { path: '/relatorioCompras', to: '/modulos/custos/relatorios/compras' },
  { path: '/relatorioConversoes', to: '/modulos/custos/relatorios/conversoes' },
  { path: '/relatorioPrecos', to: '/modulos/custos/relatorios/precos' },

  // Fidelidade
  { path: '/fidelidade/home', to: '/modulos/fidelidade' },
  { path: '/fidelidade/dashboard', to: '/modulos/fidelidade/painel' },
  { path: '/banners', to: '/modulos/fidelidade/banners' },
  { path: '/banner', to: '/modulos/fidelidade/banners/novo' },
  { path: '/banner/:id', to: '/modulos/fidelidade/banners/:id' },
  { path: '/campanhas', to: '/modulos/fidelidade/campanhas' },
  { path: '/campanha/edit', to: '/modulos/fidelidade/campanhas/novo' },
  { path: '/campanha/edit/:id', to: '/modulos/fidelidade/campanhas/:id' },
  { path: '/campanha/participacoes/:id', to: '/modulos/fidelidade/campanhas/:id/participacoes' },
  { path: '/clientes', to: '/modulos/fidelidade/clientes' },
  { path: '/cliente', to: '/modulos/fidelidade/clientes' },
  { path: '/cliente/:id', to: '/modulos/fidelidade/clientes/:id' },
  { path: '/metas', to: '/modulos/fidelidade/metas' },
  { path: '/meta', to: '/modulos/fidelidade/metas/novo' },
  { path: '/meta/:id', to: '/modulos/fidelidade/metas/:id' },
  { path: '/notificacoes', to: '/modulos/fidelidade/notificacoes' },
  { path: '/notificacao', to: '/modulos/fidelidade/notificacoes/novo' },
  { path: '/notificacao/:id', to: '/modulos/fidelidade/notificacoes/:id' },
  { path: '/sorteios', to: '/modulos/fidelidade/sorteios' },
  { path: '/sorteio', to: '/modulos/fidelidade/sorteios/novo' },
  { path: '/sorteio/:id', to: '/modulos/fidelidade/sorteios/:id' },
  { path: '/ranking', to: '/modulos/fidelidade/relatorios/ranking' },
  { path: '/relatorioPontos', to: '/modulos/fidelidade/relatorios/pontos' },
  { path: '/relatorioTrocas', to: '/modulos/fidelidade/relatorios/trocas' },
  { path: '/relatorioTroca', to: '/modulos/fidelidade/relatorios/trocas' },

  // Gerência
  { path: '/certificados', to: '/modulos/gerencia/certificados' },
  { path: '/certificado', to: '/modulos/gerencia/certificados/novo' },
  { path: '/certificado/:id', to: '/modulos/gerencia/certificados/:id' },
  { path: '/grupos', to: '/modulos/gerencia/grupos' },
  { path: '/grupo', to: '/modulos/gerencia/grupos/novo' },
  { path: '/grupo/:id', to: '/modulos/gerencia/grupos/:id' },
  { path: '/insumos', to: '/modulos/gerencia/insumos' },
  { path: '/insumo', to: '/modulos/gerencia/insumos/novo' },
  { path: '/insumo/:id', to: '/modulos/gerencia/insumos/:id' },
  { path: '/lojas', to: '/modulos/gerencia/lojas' },
  { path: '/lojas/status', to: '/modulos/gerencia/lojas/status' },
  { path: '/loja', to: '/modulos/gerencia/lojas/novo' },
  { path: '/loja/:id', to: '/modulos/gerencia/lojas/:id' },
  { path: '/mensagens', to: '/modulos/gerencia/mensagens' },
  { path: '/mensagem', to: '/modulos/gerencia/mensagens/novo' },
  { path: '/mensagem/:id', to: '/modulos/gerencia/mensagens/:id' },
  { path: '/parametros', to: '/modulos/gerencia/parametros' },
  { path: '/parametro', to: '/modulos/gerencia/parametros/novo' },
  { path: '/parametro/:id', to: '/modulos/gerencia/parametros/:id' },
  { path: '/produtos', to: '/modulos/gerencia/produtos' },
  { path: '/produto', to: '/modulos/gerencia/produtos/novo' },
  { path: '/produto/:id', to: '/modulos/gerencia/produtos/:id' },
  { path: '/unidades', to: '/modulos/gerencia/unidades' },
  { path: '/unidade', to: '/modulos/gerencia/unidades/novo' },
  { path: '/unidade/:id', to: '/modulos/gerencia/unidades/:id' },
  { path: '/usuarios', to: '/modulos/gerencia/usuarios' },
  { path: '/usuario', to: '/modulos/gerencia/usuarios/novo' },
  { path: '/usuario/:id', to: '/modulos/gerencia/usuarios/:id' },
  { path: '/relatorioLogs', to: '/modulos/gerencia/relatorios/logs' },

  // Operação
  { path: '/checklistsOperacoes', to: '/modulos/operacao/checklist-operacao' },
  { path: '/checklistsOperacoesCards/categoria/:id', to: '/modulos/operacao/checklist-operacao/execucao?categoria=:id' },
  { path: '/checklistsOperacoesCards/categorias', to: '/modulos/operacao/checklist-operacao/execucao' },
  { path: '/checklistOperacao', to: '/modulos/operacao/checklist-operacao/novo' },
  { path: '/checklistOperacao/:id', to: '/modulos/operacao/checklist-operacao/:id' },
  { path: '/respostasChecklistsOperacoes', to: '/modulos/operacao/checklist-operacao/execucao' },
  { path: '/respostaChecklistOperacao', to: '/modulos/operacao/checklist-operacao/execucao' },
  {
    path: '/respostaChecklistOperacao/checklistOperacao/:id',
    to: '/modulos/operacao/checklist-operacao/execucao/resposta/:id'
  },
  { path: '/equipamentos', to: '/modulos/operacao/equipamentos' },
  { path: '/etiquetas', to: '/modulos/operacao/etiquetas' },
  { path: '/relatorioRespostasChecklistsOperacoesImpressoes', to: '/modulos/operacao/relatorios/impressao-checklists' },

  // Suprimentos
  { path: '/pedidosCompras', to: '/modulos/suprimentos/compras' },
  { path: '/pedidoCompra', to: '/modulos/suprimentos/compras/novo' },
  { path: '/pedidoCompra/:id', to: '/modulos/suprimentos/compras/:id' },
  { path: '/fornecedores', to: '/modulos/suprimentos/fornecedores' },
  { path: '/fornecedor', to: '/modulos/suprimentos/fornecedores/novo' },
  { path: '/fornecedor/:id', to: '/modulos/suprimentos/fornecedores/:id' },
  { path: '/gruposFornecedores', to: '/modulos/suprimentos/grupos-fornecedores' },
  { path: '/grupoFornecedores', to: '/modulos/suprimentos/grupos-fornecedores/novo' },
  { path: '/grupoFornecedores/:id', to: '/modulos/suprimentos/grupos-fornecedores/:id' },
  { path: '/insumosUnidades', to: '/modulos/suprimentos/unidades-insumos' },
  { path: '/insumoUnidade', to: '/modulos/suprimentos/unidades-insumos/novo' },
  { path: '/insumoUnidade/:id', to: '/modulos/suprimentos/unidades-insumos/:id' },
  { path: '/listasPrecos', to: '/modulos/suprimentos/listas-precos' },
  { path: '/listaPreco', to: '/modulos/suprimentos/listas-precos/novo' },
  { path: '/listaPreco/:id', to: '/modulos/suprimentos/listas-precos/:id' },
  { path: '/movimentosInsumos', to: '/modulos/suprimentos/entradas-saidas-estoque' },
  { path: '/movimentoInsumo', to: '/modulos/suprimentos/entradas-saidas-estoque/novo' },
  { path: '/movimentoInsumo/:id', to: '/modulos/suprimentos/entradas-saidas-estoque/:id' },
  { path: '/relatorioContagemEstoque', to: '/modulos/suprimentos/relatorios/contagem-estoque' },
  { path: '/relatorioDivergenciasFichaTecnica', to: '/modulos/suprimentos/relatorios/divergencias-ficha-tecnica' },
  { path: '/relatorioNivelServico', to: '/modulos/suprimentos/relatorios/nivel-servico' },
  { path: '/relatorioVendasInsumos', to: '/modulos/suprimentos/relatorios/venda-insumo' },
  { path: '/relatorioVendaInsumo', to: '/modulos/suprimentos/relatorios/venda-insumo' },
  { path: '/relatorioVendasProdutos', to: '/modulos/suprimentos/relatorios/venda-produto' }
]

// Troca os :parametros do destino pelos valores da rota antiga.
export const montarDestino = (to, params = {}) =>
  to.replace(/:(\w+)/g, (trecho, nome) =>
    params[nome] !== undefined ? encodeURIComponent(params[nome]) : trecho
  )

export default rotasMigradas
